import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReqBodyCopiar, IReqBodyCrearCalendarizacion, IReqBodyEditarCalendarizacion, IResBody, IResBusquedaCalendarizacion, IResObtenerProcesos } from 'src/app/interfaces/calendarizacion';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarizacionService {

  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders()
  }

  getBusquedaCalendarizacion(anyo: number = 0, periodoId: number = 0): Observable<IResBusquedaCalendarizacion> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/busquedaCalendarizacion?anyo=${anyo}&periodo-id=${periodoId}`
    return this.http.get<IResBusquedaCalendarizacion>(url, { headers: this.getHeaders() })
  }

  getProcesos(): Observable<IResObtenerProcesos> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/obtenerProcesos`
    return this.http.get<IResObtenerProcesos>(url, { headers: this.getHeaders() })
  }

  postCopiarCalendarizacion(body: IReqBodyCopiar): Observable<IResBody> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/copiarCalendarizacion`
    return this.http.post<IResBody>(url, body, { headers: this.getHeaders() })
  }

  postCrearCalendarizacion(body: IReqBodyCrearCalendarizacion): Observable<IResBody> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/crearCalendarizacion`
    return this.http.post<IResBody>(url, body, { headers: this.getHeaders() })
  }

  postEditarCalendarizacion(body: IReqBodyEditarCalendarizacion): Observable<IResBody> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/editarCalendarizacion`
    return this.http.post<IResBody>(url, body, { headers: this.getHeaders() })
  }

  eliminarCalendarizacion(calendarizacionId: number): Observable<IResBody> {
    const url = `${environment.endpointAdministrativo}/v1/calendarizacion/eliminarCalendarizacion?calendarizacion-id=${calendarizacionId}`
    return this.http.delete<IResBody>(url, { headers: this.getHeaders() })
  }
}
